<div class="filter-slider">
  <ngx-slider
    [(value)]="minValue"
    [(highValue)]="maxValue"
    [options]="sliderOptions"
    (userChange)="onSliderChange()"
    [manualRefresh]="manualRefresh" />
</div>
